<template>
  <div>
      <topTab :changeTabIndex='6'></topTab>
      <aboutpage></aboutpage>    
      <bottomMsg></bottomMsg>
  </div>
</template>

<script>
// @ is an alias to /src
import aboutpage from "@/components/about/about.vue"
import bottomMsg from "@/components/bottomMsg/bottomMsg.vue"
import topTab from "@/components/topTab/topTab.vue"
export default {
  name: 'home',
  components: {
    aboutpage,
    bottomMsg,
    topTab
  }
}
</script>
